export const PROFILE_SEARCH_PARAM_KEYS = {
  OPEN_PREMIUM_PLAN_DIALOG: 'premium',
  OPEN_PREMIUM_WELCOME_DIALOG: 'postPurchase',
  VIDEO: 'video',
} as const

export type ProfileSearchParamKeys =
  (typeof PROFILE_SEARCH_PARAM_KEYS)[keyof typeof PROFILE_SEARCH_PARAM_KEYS]
